/*
 * @Description://字段显示值
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */

import { reactive, toRefs } from 'vue';
import dayjs from 'dayjs';
import { tools } from '@/utils/tools.js';

// 同步导入所有字段展示组件
import FieldTextShow from '@/components/fh-set-fields/components/field-show/text-field/text-field.vue';
import FieldSelectShow from '@/components/fh-set-fields/components/field-show/select/select.vue';
import FieldAvatarShow from '@/components/fh-set-fields/components/field-show/avatar/avatar.vue';
import FieldNumberShow from '@/components/fh-set-fields/components/field-show/number/number.vue';
import FieldDateShow from '@/components/fh-set-fields/components/field-show/date/date.vue';
import FieldCascadeShow from '@/components/fh-set-fields/components/field-show/cascade/cascade.vue';
import FieldLinkShow from '@/components/fh-set-fields/components/field-show/link/link.vue';
import FieldAssociationShow from '@/components/fh-set-fields/components/field-show/association/association.vue';
import FieldAmountShow from '@/components/fh-set-fields/components/field-show/amount/amount.vue';
import FieldAttachmentShow from '@/components/fh-set-fields/components/field-show/attachment/attachment.vue';
import FieldDepartShow from '@/components/fh-set-fields/components/field-show/depart/depart.vue';
import FieldPercentShow from '@/components/fh-set-fields/components/field-show/percent/percent.vue';
import FieldCalculatedShow from '@/components/fh-set-fields/components/field-show/calculated-field/calculated-field.vue';

export default function useShowFields() {
  const data = reactive({
    getEditVal: null,
    loopFieldTypes: [6, 9, 18, 22, 25] //数据格式是数组的字段类型
  });

  // // 辅助函数用于动态懒加载导入组件
  // const loadShowComponent = (path) => import(`@/components/fh-set-fields/components/field-show/${path}/${path}.vue`);
  // //字段展示组件
  // const FieldTextShow = defineAsyncComponent(() => loadShowComponent('text-field'));
  // // const FieldSelectShow = defineAsyncComponent(() => loadShowComponent('select'));
  // const FieldAvatarShow = defineAsyncComponent(() => loadShowComponent('avatar'));
  // const FieldNumberShow = defineAsyncComponent(() => loadShowComponent('number'));
  // const FieldDateShow = defineAsyncComponent(() => loadShowComponent('date'));
  // const FieldCascadeShow = defineAsyncComponent(() => loadShowComponent('cascade'));
  // const FieldLinkShow = defineAsyncComponent(() => loadShowComponent('link'));
  // const FieldAssociationShow = defineAsyncComponent(() => loadShowComponent('association'));
  // const FieldAmountShow = defineAsyncComponent(() => loadShowComponent('amount'));
  // const FieldAttachmentShow = defineAsyncComponent(() => loadShowComponent('attachment'));
  // const FieldDepartShow = defineAsyncComponent(() => loadShowComponent('depart'));
  // const FieldPercentShow = defineAsyncComponent(() => loadShowComponent('percent'));
  // const FieldCalculatedShow = defineAsyncComponent(() => loadShowComponent('calculated-field'));

  const getfieldShowCom = {
    1: FieldTextShow,
    2: FieldSelectShow,
    3: FieldSelectShow,
    4: FieldSelectShow,
    5: FieldSelectShow,
    6: FieldAvatarShow,
    7: FieldNumberShow,
    8: FieldDateShow,
    9: FieldDateShow,
    10: FieldCascadeShow,
    11: FieldLinkShow,
    12: FieldAssociationShow,
    16: FieldAmountShow,
    18: FieldAttachmentShow,
    22: FieldDepartShow,
    23: FieldPercentShow,
    24: FieldCalculatedShow,
    25: FieldAssociationShow
  };
  // 处理日期字段展示数据
  const handleFormatData = (fieldsInfo, dateRange) => {
    const fieldType = fieldsInfo?.fieldType;

    if (fieldType === 9) {
      if (!dateRange) {
        return '';
      }
      const dateItem = tools.isJSON(dateRange) ? JSON.parse(dateRange) : {};
      return dateItem.beginDate && dateItem.endDate ? `${dateItem.beginDate || ''}/${dateItem.endDate || ''}` : null;
    } else {
      const fieldextInfo = fieldsInfo?.fieldExt || null;
      return fieldextInfo ? dayjs(dateRange ? dateRange : new Date()).format(fieldextInfo) : dateRange ? dateRange : '';
    }
  };
  // 处理字段展示数据
  const handleDataProcessing = (fieldsInfo) => {
    // 提前获取常用变量
    const fieldType = fieldsInfo?.fieldType;
    const fieldValue = fieldsInfo?.fieldValue;

    if ([8, 9].includes(fieldType)) {
      // 处理日期，日期范围类型
      if (fieldType === 9) {
        const dateRange = tools.isJSON(fieldValue) ? JSON.parse(fieldValue) : {};
        data.getEditVal = dateRange ? [dateRange?.beginDate || '', dateRange?.endDate || ''] : '';
        return handleFormatData(fieldsInfo, fieldValue);
      } else {
        // 处理单值日期
        const showDateValue = handleFormatData(fieldsInfo, fieldValue);

        data.getEditVal = showDateValue;
        return showDateValue;
      }
    }
  };
  return {
    getfieldShowCom,
    handleDataProcessing,
    ...toRefs(data)
  };
}
